module.exports = __webpack_public_path__ + "static/img/led_difuso_amarelo_5mm-1.9c26212.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/led_difuso_amarelo_5mm-1.svg
// module id = u6lI
// module chunks = 0